import { searchParametersActions } from 'features/searchResultsFacets';
import CheckboxGroup from '@components/checkbox';
import { store, store$ } from '@redux/store';
import { distinctUntilChanged, map } from 'rxjs';
import { selectRvGarage } from '../redux/selectors';

const checkbox = document.querySelector('[data-rv-garage-filter]');
const rvGarage$ = new CheckboxGroup(checkbox).getObservable();
const setValue = (value) => {
  checkbox.checked = value || false;
};

rvGarage$.subscribe((value) => {
  const payload = !!value.length;
  store.dispatch(searchParametersActions.fetchRvGarages(payload));
});

store$.pipe(map(selectRvGarage), distinctUntilChanged()).subscribe(setValue);
